import { useState, useEffect } from "react";
import * as AppUIService from "services/appService";
import AppUIModel from 'models/AppUI'


export const useGetDetailAppUI = (id) => {
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getDataDetail = async () => {
        setIsLoading(true);
        try {
            const response = await AppUIService.getDetailAppUI(id);
            if(response && response.status === 200) {
                setData( new AppUIModel(response.data.data))
            }
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if(id){
            getDataDetail()
        }
    },[id])

    const reload = () => {
        getDataDetail()
    }

    return {data, isLoading, error, reload}
}